"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.minutesToString = exports.timeHandler = void 0;
const timeHandler = (date) => {
    if (date) {
        const [, time] = date.split('T');
        if (time) {
            const [timeReturn] = time.split('Z');
            return timeReturn || '';
        }
        return '';
    }
    return '';
};
exports.timeHandler = timeHandler;
const minutesToString = (value) => {
    const hours = value ? Math.floor(value / 60) : 0;
    const minutes = value ? value % 60 : 0;
    const strHours = hours ? `${hours} Hours ` : '';
    const strMinutes = `${minutes} Minutes`;
    return strHours.concat(strMinutes);
};
exports.minutesToString = minutesToString;
